import { useCallback, useEffect, useState } from 'react';

import ApiService from '../../common/ApiCalls';
import { mergeValuesIntoCards } from '../shared/utils/merge-values-to-cards';

/**
 * Hook for retrieving fields data on the Full Details Page by particular tab
 * @param {*} layout
 * @param {string} tabId
 * @returns {{
 * entityCards: Array<import("./use-form-data").FieldsData>;
 * selectEntity: Dispatch<SetStateAction<string>>;
 * setEntityLayout: Dispatch<SetStateAction<any>>;
 * updateEntityValues: (values: Record<string, unknown>) => void;
 * }}
 */
export const useFetchFieldData = (tabId) => {
  const [selectedEntityId, setSelectedEntityId] = useState('');
  const [entityLayout, setEntityLayout] = useState(null);
  const [entityCards, setEntityCards] = useState([]);
  const [loading, setLoading] = useState(false);

  const updateEntityValues = useCallback((values) => {
    setEntityCards((cards) => mergeValuesIntoCards(cards, values));
  }, []);

  useEffect(() => {
    if (!selectedEntityId) {
      return;
    }

    const fetchFieldData = async (tabId, entityId, layout) => {
      if (!layout || !tabId) {
        return [];
      }

      const fieldIds = [];
      layout.cards.forEach((card) => {
        card.items.forEach((field) => {
          if (field.item_type === 'field') {
            fieldIds.push(field.field_id);
          }
        });
      });

      if (fieldIds.length === 0) {
        return layout.cards;
      }

      try {
        setLoading(true);
        const valuesData = await ApiService().getValues(
          tabId,
          'asset',
          entityId
        );
        const mappedValues = (valuesData || []).reduce((acc, value) => {
          acc[value.field_id] = value.value;

          return acc;
        }, {});

        const merged = mergeValuesIntoCards(layout.cards, mappedValues);

        setEntityCards(merged);
      } catch (error) {
        console.error('Error loading party values:', error);
        return [];
      } finally {
        setLoading(true);
      }
    };

    fetchFieldData(tabId, selectedEntityId, entityLayout);
  }, [tabId, selectedEntityId, entityLayout]);

  return {
    entityCards,
    loading,

    selectEntity: setSelectedEntityId,
    setEntityLayout,
    updateEntityValues
  };
};
